[
  {
    "id": "SWW-E6P-L106-001",
    "module": "SpellingWW",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "question": "Gisteren ... hij naar de winkel. (lopen)",
    "options": ["liep", "loopt", "liepen", "gelopen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_sterk_context",
    "familyId": "SWW-VT-STERK-CONTEXT",
    "conceptId": "past_tense_strong_context_choice",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' kies je verleden tijd.\n'Lopen' is een sterk werkwoord.\nDe verleden tijd enkelvoud is: liep.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. 'Gisteren' vraagt verleden tijd.",
      "2": "Dit is verleden tijd meervoud. Het onderwerp is enkelvoud: hij liep.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft': hij heeft gelopen."
    }
  },
  {
    "id": "SWW-E6P-L106-002",
    "module": "SpellingWW",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "question": "Wij ... al een uur in de rij. (staan)",
    "options": ["staan", "stonden", "hebben gestaan", "gestaan"],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "werkwoordvormen",
    "subSkill": "voltooide_tijd_met_duur",
    "familyId": "SWW-TIJD-VTDT-CONTEXT",
    "conceptId": "present_perfect_with_duration_context",
    "variantIndex": 2,
    "explanation": "De woorden 'al een uur' geven aan dat het eerder begon en nog geldt.\nDan gebruik je voltooide tijd: hebben gestaan.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd, maar bij 'al een uur' klinkt voltooide tijd logischer: hebben gestaan.",
      "2": "Dit is verleden tijd en voelt afgerond. De zin laat juist zien dat het nog doorloopt.",
      "3": "Dit is alleen het voltooid deelwoord. Je hebt ook een hulpwerkwoord nodig: hebben gestaan."
    }
  },
  {
    "id": "SWW-E6P-L106-003",
    "module": "SpellingWW",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "question": "De deur wordt ... (sluiten).",
    "options": ["gesloten", "gesloot", "sluit", "geslotene"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "lijdende_vorm",
    "familyId": "SWW-LIJDENDE-VORM-VD",
    "conceptId": "passive_voice_past_participle",
    "variantIndex": 2,
    "explanation": "Bij een lijdende vorm gebruik je: wordt + voltooid deelwoord.\nHet voltooid deelwoord van 'sluiten' is gesloten.",
    "distractorExplanations": {
      "1": "Dit is geen juiste spelling van het voltooid deelwoord van 'sluiten'.",
      "2": "Dit is tegenwoordige tijd en past niet na 'wordt'.",
      "3": "Dit is een bijvoeglijke vorm die je hier niet nodig hebt."
    }
  },
  {
    "id": "SWW-E6P-L106-004",
    "module": "SpellingWW",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "question": "Hij heeft de bal ... (trappen).",
    "options": ["getrapt", "getrapd", "trapte", "trapt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_zwak_tkofschip",
    "familyId": "SWW-VD-ZWAK-TKOF-KEUZE",
    "conceptId": "past_participle_weak_t_rule",
    "variantIndex": 2,
    "explanation": "Na 'heeft' gebruik je een voltooid deelwoord.\nStam van 'trappen' is 'trap'.\nDe p zit in 't kofschip, dus het voltooid deelwoord eindigt op t: getrapt.",
    "distractorExplanations": {
      "1": "Je kiest d, maar p zit in 't kofschip. Daarom moet het t zijn: getrapt.",
      "2": "Dit is verleden tijd. Na 'heeft' hoort het voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd. Na 'heeft' hoort het voltooid deelwoord."
    }
  },
  {
    "id": "SWW-E6P-L106-005",
    "module": "SpellingWW",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "question": "De ... taart stond op tafel. (bakken)",
    "options": ["gebakken", "gebakte", "gebakt", "bakten"],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bnvd_enkelvoud_de",
    "familyId": "SWW-BNVD-E-ENKELVOUD-DE",
    "conceptId": "bnvd_from_strong_past_participle",
    "variantIndex": 1,
    "explanation": "Je beschrijft de taart, dus je gebruikt het bijvoeglijk gebruikte voltooid deelwoord.\nHet voltooid deelwoord van 'bakken' is 'gebakken'.\nBij een de-woord komt er meestal een -e achter: gebakken → gebakte.",
    "distractorExplanations": {
      "1": "Dit is het voltooid deelwoord zonder -e. In deze zin beschrijf je de taart, dus je hebt de bijvoeglijke vorm nodig.",
      "2": "Dit is een andere vorm die je wel eens als bijvoeglijk ziet, maar bij 'bakken' wordt in dit soort oefeningen meestal 'gebakte' verwacht als bijvoeglijke vorm.",
      "3": "Dit is verleden tijd meervoud. De zin vraagt om een beschrijving van de taart, niet om een handeling."
    }
  }
]
